namespace Portico.Models.Enterprise {
    import psgm = apigateway.models;

    export interface IPointOfContact {
        id: number;
        firstName: string;
        lastName: string;
        phoneNumber: string;
        phoneNumberExtension: string;
        faxNumber: string;
        //site point of contacts properties
        jobTitle: string;
        emailAddress: string;
        preferredContactMethod: string;
    }

    export class PointOfContact implements IPointOfContact {
        id: number;
        firstName: string;
        lastName: string;
        phoneNumber: string;
        phoneNumberExtension: string;
        faxNumber: string;
        //site point of contacts properties
        jobTitle: string;
        emailAddress: string;
        preferredContactMethod: string;

		constructor(obj?: IPointOfContact | psgm.PharmacyPointOfContactModel | any) {
            this.id = null;
            this.firstName = '';
            this.lastName = '';
            this.phoneNumber = '';
            this.phoneNumberExtension = '';
            this.faxNumber = '';
            this.jobTitle = '';
            this.emailAddress = '';
			this.preferredContactMethod = 'UNKNOWN';

            if (obj) {
                this.id = obj.id || null;
				this.firstName = obj.firstName || '';
				this.lastName = obj.lastName || '';
				this.phoneNumber = obj.phoneNumber || '';
				this.phoneNumberExtension = obj.phoneNumberExtension || '';
				this.faxNumber = obj.faxNumber || '';
				this.jobTitle = obj.jobTitle || '';
				this.emailAddress = obj.emailAddress || '';
				this.preferredContactMethod = obj.preferredContactMethod || 'UNKNOWN';
            }
        }
    }
}